<template lang="html">
  <div class="page-container">
    <div class="articles-search__back" @click="changeArticlesSearch(null)" v-if="articlesSearch">
      <svg class="pagination__item__icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="15 18 9 12 15 6" />
      </svg>
      Înapoi
    </div>

    <!-- Header -->
    <div class="articles__title">
      <h1 class="header-1" v-if="articlesSearch">
        Rezultate pentru:
        <span @click="changeArticlesSearch(null)">
          "{{ articlesSearch }}"
        </span>
        <template v-if="categoriesCurrent !== null">
          în categoria <b>{{ categoriesCurrent.name }}</b>
        </template>
      </h1>
      <h1 class="header-1" v-else>
        Articole
      </h1>

      <form class="articles__title__form" method="GET" onsubmit="return false;" v-if="!(articlesSearch)">
        <input
          @keyup.enter="changeArticlesSearch($event.target.value)"
          class="articles__title__input"
          :placeholder="
            categoriesCurrent === null
              ? 'Caută articole...'
              : `Caută articole în ${ categoriesCurrent.name }`
          "
          type="text"
          :value="articlesSearch"
        />

        <svg class="articles__title__icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
      </form>
    </div>

    <!-- Search Results -->
    <template v-if="articlesSearch">
      <div class="articles-search__list-container">
        <!-- Category Menu -->
        <CategoryMenu />

        <!-- Feed -->
        <div class="articles__list-container__feed" v-if="articlesLoading">
          <ArticleCard :searched="true" :skeleton="true" :key="0" />
          <ArticleCard :searched="true" :skeleton="true" :key="1" />
          <ArticleCard :searched="true" :skeleton="true" :key="2" />
          <ArticleCard :searched="true" :skeleton="true" :key="3" />
        </div>
        <div class="articles__list-container__feed" v-else-if="articles.length === 0">
          <template v-if="categoriesCurrent === null">
            Nu s-a gasit nici un rezultat pentru căutarea <b>{{ articlesSearch }}</b>.
          </template>
          <template v-else>
            Nu s-a gasit nici un rezultat pentru căutarea <b>{{ articlesSearch }}</b> pentru categoria <b>{{ categoriesCurrent.name }}</b>.
          </template>
        </div>
        <div class="articles__list-container__feed" v-else>
          <ArticleCard v-for="article in articles" :article="article" :searched="true" :key="article.id" />
        </div>

        <!-- Search Pagination -->
        <div style="height: 100px; width: 100%;" v-if="articlesLoading || (articlesPageLast === 1)" />
        <Pagination class="articles__pagination-container" v-else />
      </div>
    </template>

    <!-- Feed -->
    <div class="articles__feed__container" v-else>
      <!-- Category Menu -->
      <CategoryMenu />

      <!-- Feed -->
      <div class="articles__list-container page-container">
        <div class="articles__list-container__feed" v-if="articlesLoading">
          <ArticleCard :skeleton="true" :key="0" />
          <ArticleCard :skeleton="true" :key="1" />
          <ArticleCard :skeleton="true" :key="2" />
          <ArticleCard :skeleton="true" :key="3" />
        </div>
        <div class="articles__list-container__feed" v-else-if="articles.length === 0">
          <template v-if="categoriesCurrent === null">
            Nu sunt articole disponibile la acest moment.
          </template>
          <template v-else>
            Nu sunt articole disponibile la acest moment pentru categoria <b>{{ categoriesCurrent.name }}</b>.
          </template>
        </div>
        <div class="articles__list-container__feed" v-else>
          <ArticleCard v-for="article in articles" :article="article" :key="article.id" />
        </div>

        <div class="articles__list-container__featured" v-if="articlesTopLoading">
          <ArticleCard :featured="true" :skeleton="true" :key="0" />
          <ArticleCard :featured="true" :skeleton="true" :key="1" />
          <ArticleCard :featured="true" :skeleton="true" :key="2" />
          <ArticleCard :featured="true" :skeleton="true" :key="3" />
          <ArticleCard :featured="true" :skeleton="true" :key="4" />
        </div>
        <div class="articles__list-container__featured" v-else>
          <ArticleCard v-for="article in articlesTop" :article="article" :featured="true" :key="article.id" />
        </div>
      </div>

      <!-- Pagination -->
      <div style="height: 100px; width: 100%;" v-if="articlesLoading || (articlesPageLast === 1)" />
      <Pagination class="articles__pagination-container" style="margin-bottom: 40px" v-else />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ArticleCard                from './components/ArticleCard';
import CategoryMenu               from './components/CategoryMenu';
import Pagination                 from './components/Pagination';

export default {
  components: {
    ArticleCard,
    CategoryMenu,
    Pagination
  },
  mounted() {
    if (this.$route.query.q) {
      this.changeArticlesSearch(this.$route.query.q);
    }

    if (this.articles.length === 0) {
      this.fetchArticles();
    }

    if (this.articlesTop.length === 0) {
      this.fetchArticlesTop();
    }
  },
  computed: {
    ...mapGetters({
      articles           : 'articles/articles',
      articlesLoading    : 'articles/articlesLoading',
      articlesPageLast   : 'articles/articlesPageLast',
      articlesSearch     : 'articles/articlesSearch',
      articlesTop        : 'articles/articlesTop',
      articlesTopLoading : 'articles/articlesTopLoading',
      categoriesCurrent  : 'articles/categoriesCurrent',
    }),
  },
  methods: {
    ...mapActions({
      changeArticlesSearch : 'articles/changeArticlesSearch',
      fetchArticles        : 'articles/fetchArticles',
      fetchArticlesTop     : 'articles/fetchArticlesTop',
    }),
  },
  watch: {
    '$route.query.q'(newValue, oldValue) {
      if (oldValue && !(newValue) && !(this.$route.query.q)) {
        this.changeArticlesSearch(null);
      } else {
        this.changeArticlesSearch(this.$route.query.q);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/scss/pages/articles';
  @import '@/scss/pages/articles-search';

  .articles-search__list-container {
    background: white;
    padding-bottom: 40px;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 20px;

    @media only screen and (max-width: 1500px) {
      box-sizing: border-box;
      padding-bottom: 20px;
      padding-left: 0;
      padding-right: 0;
    }

    @media only screen and (min-width: 1500px) {
      box-shadow: 0px 0px 20px #0000000f;
      margin-bottom: 100px;
    }

    & > .articles__list-container__feed {
      margin-top: 40px;
      padding-left: 10px;
      padding-right: 10px;

      @include media-breakpoint-up(md) {
        padding-left: 20px;
        padding-right: 20px;
      }
    }
  }

  .articles__feed__container {
    background: white;
    margin-top: 40px;
    box-sizing: content-box;
    padding-bottom: 40px;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 20px;

    @media only screen and (max-width: 1500px) {
      box-sizing: border-box;
      padding-bottom: 20px;
      padding-left: 0;
      padding-right: 0;
    }

    @media only screen and (min-width: 1500px) {
      box-shadow: 0px 0px 20px #0000000f;
      margin-bottom: 100px;
    }
  }

  .articles__title.page-container {
    @media only screen and (min-width: 1500px) {
      //box-sizing: content-box;
    }
  }
</style>
